//convert T[1,2,3,4,5,6] to T[[1,2], [3,4], [5,6]] with equal length (rowCount = 2)
export const convertArrayToMultidimensional = <T>(inputArray: T[], rowCount: number): T[][] => {
    const initialArray: T[][] = [];
    if (!inputArray || rowCount < 1) return initialArray;

    return inputArray.reduce((resultArray, currentItem, currentIndex) => {
        //column is full -> start new column
        if (currentIndex % rowCount === 0) {
            resultArray.push([]);
        }

        //add current item to the last column
        const lastColumn = resultArray[resultArray.length - 1];
        lastColumn.push(currentItem);

        return resultArray;
    }, initialArray);
};
